import React from 'react'
import { SocketProvider } from './SocketContext'
import { UserPermissionsProvider } from './UserPermissionsContext'

export const ContextProviders: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <SocketProvider>
      <UserPermissionsProvider>{children}</UserPermissionsProvider>
    </SocketProvider>
  )
}
